// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import { cloneDeep, isEmpty, set } from 'lodash';

import {
  RECEIVE_SEARCH_RESULTS,
  PENDING_SEARCH_RESULTS,
  FETCH_ERROR,
} from '~/client/lib/actions';

/**
 * The initial state of search reducer state.
 *
 */
function getInitialState() {
  return {
    results: {
      hits: [],
      facets: {},
      count: 0,
    },
    query: {},
    suggestions: [],
    error: false,
  };
}

export default (state = getInitialState(), action = {}) => {
  let newState = state;

  if (isEmpty(state)) {
    return getInitialState();
  }

  switch (action.type) {
    case RECEIVE_SEARCH_RESULTS: {
      const { data, query } = action;
      const { facets, total } = data;

      newState = cloneDeep(newState);
      newState.error = false;
      newState.results = {
        ...newState.results,
        facets: facets || {},
        hits: data.nw_pages,
        count: total,
      };
      newState.query = query;

      break;
    }
    case PENDING_SEARCH_RESULTS:
      newState = {
        ...state,
      };
      set(newState, 'results.pending', action.pending);
      break;
    case FETCH_ERROR:
      newState = {
        ...state,
      };
      newState.error = true;
      set(newState, 'results.pending', action.pending);
      break;
    default:
    // do nothing
  }

  // Return the new state.
  return newState;
};
